(function () {
  'use strict';

  function boot() {
    var svg = document.querySelector('.luxe-hero__metric svg');
    if (!svg) return;

    var gsap = window.gsap;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!gsap || reduce) {
      if (gsap) gsap.set(svg, { autoAlpha: 1 });
      else svg.style.visibility = 'visible';
      return;
    }

    if (window.CustomEase) window.CustomEase.create('metricSmooth', '0.16, 1, 0.3, 1');
    var ease = window.CustomEase ? 'metricSmooth' : 'power3.out';

    var inner = svg.querySelector('#inner-metric');
    var outer = svg.querySelector('#outer-metric');
    var RING_ORIGIN = '776 595';

    gsap.set(svg, { autoAlpha: 0, scale: 1.2, rotation: 12, transformOrigin: '50% 50%' });

    var tl = gsap.timeline({ defaults: { duration: 3, ease: ease } });
    tl.to(svg, { autoAlpha: 1, scale: 1, rotation: 0 }, 0);
    if (inner) tl.from(inner, { rotation: -300, svgOrigin: RING_ORIGIN }, 0);
    if (outer) tl.from(outer, { rotation: 300, svgOrigin: RING_ORIGIN }, 0);
  }

  function ready() {
    var root = document.querySelector('[data-luxe][data-hero-3d]');
    if (root) return;

    var metric = document.querySelector('.luxe-hero__metric-shell');
    if (!metric) return;

    if (window.__czardIntro) {
      if (metric.querySelector('svg')) boot();
      else document.addEventListener('czard:metric-ready', boot, { once: true });
      return;
    }

    document.addEventListener('czard:intro', function () {
      if (metric.querySelector('svg')) boot();
      else document.addEventListener('czard:metric-ready', boot, { once: true });
    }, { once: true });
  }

  if (document.readyState !== 'loading') ready();
  else document.addEventListener('DOMContentLoaded', ready);
})();
